import {DI_TOKENS} from '@/di/di.tokens';
import {ErrorAction} from '@/services/ErrorService/ErrorService.constants';

import {injected} from 'brandi';

import {ProjectUserAuth} from '@specials/project-user';

import {NavigationService} from '@/services/NavigationService/NavigationService';
import {ProjectUserInfoData, ProjectUserLoginData} from '@/services/ProjectAuthApi/types';
import {OpenItemSharedUseCase} from '@/useCases/shared/OpenItemSharedUseCase/OpenItemSharedUseCase';

export class ErrorActionHandlerUseCase {
  constructor(
    private readonly projectUserAuth: ProjectUserAuth<ProjectUserInfoData, ProjectUserLoginData>,
    private readonly navigationService: NavigationService,
    private readonly openItemSharedUseCase: OpenItemSharedUseCase,
  ) {}

  public handleErrorAction = async (action: ErrorAction, data?: string): Promise<void> => {
    switch (action) {
      case ErrorAction.Logout: {
        void this.logout();
        break;
      }

      case ErrorAction.Reload: {
        // TODO: Для МБ необходимо перезагрузить с query пользователя
        // Сейчас query чистятся
        // Решить проблему тут https://jira.tcsbank.ru/browse/SP-18532
        this.reloadPage();
        break;
      }

      case ErrorAction.LogoutWithReload: {
        await this.logout();
        this.reloadPage();
        break;
      }

      case ErrorAction.ReopenItem: {
        if (data) {
          void this.reopenItem(data);
        }
        break;
      }

      case ErrorAction.ReopenBonus: {
        if (data) {
          void this.reopenBonus(data);
        }
        break;
      }
    }
  };

  private logout = async (): Promise<void> => {
    await this.projectUserAuth.logout();
  };

  private reloadPage = (): void => {
    this.navigationService.pageReload();
  };

  private reopenItem = async (data: string): Promise<void> => {
    await this.openItemSharedUseCase.openItem(data);
  };

  private reopenBonus = async (data: string): Promise<void> => {
    await this.openItemSharedUseCase.openBonus(data);
  };
}

injected(
  ErrorActionHandlerUseCase,
  DI_TOKENS.projectUserAuth,
  DI_TOKENS.navigationService,
  DI_TOKENS.openItemSharedUseCase,
);
